<template>
  <div class="copy-cell" :title="label">
    {{ showLabel }}
    <span :class="tipClass" v-if="showTip">
      <template v-if="success">
        <i class="cicon-check_small"></i>复制成功！
      </template>
      <template v-else>
        <i class="cicon-delete-little1"></i>复制失败,请手动复制
      </template>
    </span>
    <button :data-clipboard-text="label" ref="whole-cell-copy" class="c-button c-button-border-normal c-button-size-small">复制</button>
  </div>
</template>

<script>
import { util } from '../../utils'
export default {
  name: 'copyCell',
  props: {
    label: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      success: false,
      showTip: false,
      copyHandle: null
    }
  },
  computed: {
    showLabel () {
      let label = this.label
      return this.$util.strMiddleSplit(label, {
        maxLength: 33,
        beginLength: 15,
        endLength: 15,
        replaceStr: '...'
      })
    },
    tipClass () {
      return {
        'copy-tip': true,
        success: this.success,
        fail: !this.success
      }
    }
  },
  mounted () {
    this.copyHandle = util.copy(this.$refs['whole-cell-copy'], () => {
      this.success = true
      this.showTip = true
      setTimeout(() => {
        this.showTip = false
      }, 1000)
    }, () => {
      this.success = false
      this.showTip = true
      setTimeout(() => {
        this.showTip = false
      }, 1000)
    })
  },
  beforeDestroy () {
    if (this.copyHandle) {
      this.copyHandle.destroy()
    }
  }
}
</script>

<style lang="sass">
@import "styles/copyCell"
</style>
